import {
  RenderCollection as Collection,
  createRenderMiddleware as createMiddleware,
} from 'smarthub-core'
import {
  coreComponentMiddleware as core  
} from 'smarthub-components'
import { IMiddlewareConfig, IRenderHandler, RenderMiddleware } from 'smarthub-common'

export const renderMiddleware = (): IMiddlewareConfig<RenderMiddleware, IRenderHandler> => {
  const collection = new Collection()
  const middleware = createMiddleware(core, collection.middleware)
  return {
    middleware,
    collection,
  }
}
